document.addEventListener('DOMContentLoaded', function() {
  const form = document.querySelector('form[action="/cart/add"]');
  if (!form) return;

  const variantSelectors = form.querySelectorAll('select[name^="options"]');
  const variantDataEl = document.querySelector('[data-product-variants]');
  if (!variantDataEl) return;

  const variants = JSON.parse(variantDataEl.textContent);

  form.addEventListener('submit', function(e) {
    const selectedOptions = Array.from(variantSelectors).map(sel => sel.value);
    const match = variants.find(v =>
      v.options.every((opt, i) => opt === selectedOptions[i])
    );

    if (match) {
      const idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = match.id;
    }
  });

  // Disable out-of-stock options
  variantSelectors.forEach(select => {
    select.querySelectorAll('option').forEach(option => {
      const matchingVariant = variants.find(v => v.options.includes(option.value));
      if (matchingVariant && matchingVariant.inventory_quantity <= 0) {
        option.disabled = true;
      }
    });
  });
});
